import React from 'react';
import _ from 'lodash';
import propTypes from 'prop-types';
import TextField from '../text-field/text-field';
import PhoneField from '../phone-field/phone-field';
import mergeI18n from '../../lib/util/merge-i18n';
import i18n from './i18n';
import Icon from '../icon/icon';
import validateContact from './validation';
import { handleBlur, handleInputChange, getFormError } from '../../lib/form';
import { ACCOUNT_ROUTE, LOCATION_ROUTE, LOG_IN_ROUTE } from '../../constants/constants';

class Contact extends React.Component {
	constructor (props) {
		super(props);

		this.handleInputChange = handleInputChange.bind(this);
		this.handleBlur = handleBlur.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			phone: '',
			phoneType: 'mobile',
			email: '',
			// TODO: Re-enable preferred contact method later
			// prefContactMethod: '',
			formErrors: [],
			blurredFields: []
		};
	}

	componentDidMount () {
		if (_.isEmpty(this.props.inspectionRequest)) {
			this.props.setRoute(LOG_IN_ROUTE);
		} else {
			this.props.setParentState({
				progressIndex: 1,
				canLogOut: false,
				canGoToHomePage: false
			});
		}
	}

	handleSubmit () {
		if (this.state.formErrors.length === 0) {
			this.props.setParentState({
				contact: {
					phone: this.state.phone,
					email: this.state.email,
					prefContactMethod: 'phone'
					// TODO: Re-enable preferred contact method later (prefContactMethod: string.isRequired)
				}
			});
			this.props.setRoute(LOCATION_ROUTE);
		}
	}

	render () {
		// Dispite changing the route in componentDidMount React will attempt to render this
		// at least once, so we're doing this to avoid a crash
		if (_.isEmpty(this.props.inspectionRequest)) {
			return (<div />);
		}

		const __ = mergeI18n(this.props.language, i18n);

		const handleFormError = getFormError(this.state.blurredFields, this.state.formErrors, __.validation);

		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content'>
				<div id='contact' className='row'>
					<div className='col-sm-12 col-md-6 col-md-offset-3'>
						<form id='contact-form' onSubmit={this.handleSubmit}>
							<h1>{__.title}</h1>
							<h2>{__.subTitle}</h2>
							<div className='row'>
								<div className='col-md-6'>
									<PhoneField
										language={this.props.language}
										label={__.inputs.phone.label}
										ios={window.navigator.userAgent.match(/iPad/i) || window.navigator.userAgent.match(/iPhone/i)}
										phoneName='phone'
										phoneValue={this.state.phone}
										phoneTypeName='phoneType'
										phoneTypeValue={this.state.phoneType}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateContact)}
										formError={handleFormError('phone') || handleFormError('phoneType')}
									/>
									<div className='row'>
										<div className='col-xs-12'>
											<TextField
												label={__.inputs.email.label}
												placeholder={__.inputs.email.placeholder}
												type='email'
												name='email'
												value={this.state.email}
												onChange={this.handleInputChange}
												onBlur={(e) => this.handleBlur(e, validateContact)}
												formError={handleFormError('email')}
											/>
										</div>
									</div>

									{/* TODO: perfered contact method
										<RadioGroup
											hide='true'
											label={preferredContactMethods[this.props.language].label}
											name='prefContactMethod'
											value={this.state.prefContactMethod}
											onChange={this.handleInputChange}
											onBlur={(e) => this.handleBlur(e, validateContact)}
											options={filterPrefContactMethods(this.props.language, this.state.phoneType)}
											formError={handleFormError('prefContactMethod')}
											checked={this.state.prefContactMethod}
										/>
									*/}

									{this.state.phoneType === 'mobile' && this.state.prefContactMethod === 'sms' ? (
										<div className='sms-legal'>
											{__.smsLegal()}
										</div>
									) : null}

								</div>
							</div>

							<div className='flex-button-spacer' />
							<div className='row'>
								<div className='col-sm-12 col-md-4 col-md-offset-8'>
									<button
										id='go-back'
										className='btn btn-default back-button'
										type='button'
										onClick={() => this.props.setRoute(ACCOUNT_ROUTE)}
									>
										<Icon name='MdChevronLeft' /> {__.backButton}
									</button>
									<button
										id='submit-form'
										className='btn btn-primary'
										type='submit'
										disabled={this.state.formErrors.length > 0 || this.state.blurredFields.length === 0}
									>
										{__.continueButton} <Icon name='MdChevronRight' />
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

Contact.propTypes = {
	inspectionRequest: propTypes.shape({
		lesseeFirstName: propTypes.string,
		lesseeLastName: propTypes.string,
		lesseeEmail: propTypes.string,
		vehicles: propTypes.arrayOf(propTypes.shape({
			vin: propTypes.string.isRequired,
			make: propTypes.string,
			model: propTypes.string,
			year: propTypes.string
		}))
	}),
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default Contact;
